// extracted by mini-css-extract-plugin
export default {"headerNavItem":"HeaderNavItem_headerNavItem__+Y9BZ","headerNavImage":"HeaderNavItem_headerNavImage__yHtpA","headerNavText":"HeaderNavItem_headerNavText__xkGAz"};